import { ClipboardEventHandler } from 'react';

import { showInfoToast } from 'src/components/Toasts/toast';

export const disableCopyEventHandler: ClipboardEventHandler<HTMLTableCellElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    showInfoToast('Copying is disabled.');
};

export const disableCutEventHandler: ClipboardEventHandler<HTMLTableCellElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    showInfoToast('Cutting is disabled.');
};
